<template>
  <v-container fill-height fill-width grid-list-md text-xs-center>
    <div class="color"></div>
    <div class="texture"></div>
    <div class="photo"></div>
    <v-layout column align-center>
      <div class="brand">
        <v-img src="@/assets/images/marca-pautaria-invertida-color.svg" />
      </div>
      <v-flex v-if="shouldUseCatraca()">
        <v-text-field
          v-model="auth.username"
          label="Usuário"
          placeholder="Informe seu usuário corp"
          dark
          color="primary"
          class="textfield"
          height="48px"
          background-color="transparent"
          hide-details
          autocomplete="new-password"
        />

        <v-text-field
          v-model="auth.password"
          label="Senha"
          placeholder="Informe sua senha corp"
          dark
          color="primary"
          class="textfield"
          height="48px"
          background-color="transparent"
          hide-details
          :type="showPassword ? 'text' : 'password'"
          :append-icon="showPassword ? 'visibility' : 'visibility_off'"
          @click:append="showPassword = !showPassword"
          @keyup.enter="submitForm"
          autocomplete="new-password"
        />
      </v-flex>
      <v-flex class="submit">
        <v-btn
          x-large
          block
          elevation="8"
          @click="submitForm()"
          :loading="isLoading"
          color="primary"
          dark
          >Entrar</v-btn
        >
        <v-btn class="link" @click="dialog = true" text large block dark
          >Precisa de ajuda para entrar?</v-btn
        >

        <!-- MODAL > Ajuda -->
        <v-dialog v-model="dialog" max-width="480">
          <v-card>
            <v-row>
              <v-icon color="gray">help_outline</v-icon>
            </v-row>
            <v-card-title class="headline">Instruções</v-card-title>
            <v-card-text>
              Acesse o NewsHub utilizando seu usuário da Globo, as mesmas
              credenciais que você usa para acessar o outlook, por exemplo :)
            </v-card-text>
            <v-card-text class="extra">
              Se precisar de ajuda, fale com o Help Desk!<br />
              Ligue para <span>3911</span> se estiver na Globo<br />
              Se estiver fora, ligue para <span>0800 728 4855</span>
            </v-card-text>
            <v-card-actions>
              <div class="flex-grow-1"></div>
              <v-btn color="primary" large outlined text @click="dialog = false"
                >Entendi</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
        <!-- FIM DA MODAL -->

        <!-- INICIO DO SNACKBAR -->
        <v-snackbar v-model="snackbar" :multi-line="true"
          >{{ errorMessage }}
          <v-btn color="primary" text @click="hideSnackbar()">Entendi</v-btn>
        </v-snackbar>
        <!-- FIM DO SNACKBAR -->
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import { categories, actions } from '@/constants/analytics.js';

export default {
  name: 'login',
  data() {
    return {
      showPassword: false,
      dialog: false,
      message: null,
      auth: {},
    };
  },
  computed: {
    ...mapGetters(['isLoading']),
    ...mapState({
      isLoggedIn: state => !!state.user.isLoggedIn,
      errorMessage: state => state.user.errorMessage,
    }),
    snackbar: {
      get() {
        return this.$store.state.user.snackbar;
      },
      set(value) {
        this.$store.commit('SHOW_SNACKBAR', value);
      },
    },
  },
  methods: {
    hideSnackbar() {
      this.$store.commit('SHOW_SNACKBAR', false);
    },
    shouldUseCatraca() {
      return process.env.VUE_APP_OPENID_AUTH_ENABLED.includes('false');
    },
    submitForm: function() {
      if (this.shouldUseCatraca()) {
        this.loginCatraca();
      } else {
        this.loginOID();
      }
    },
    loginCatraca() {
      if (!this.validEmail(this.auth.username)) {
        this.$store.dispatch('analyticsEvent', {
          category: categories.login,
          action: actions.loginAttempt,
          label: this.auth.username,
        });
        this.$store.dispatch('loginCatraca', this.auth);
      } else {
        this.$store.dispatch(
          'showSnackbarWithMessage',
          'Não utilizar o seu e-mail, favor entrar com seu usuário corporativo.',
        );
      }
    },
    loginOID() {
      window.location = `${process.env.VUE_APP_URL_NEW_NH}/mirrors`;
    },
    validEmail: function(username) {
      let re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(username);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/theme.scss';
@import '@/assets/scss/theme-v2.scss';

.container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 100%;
  height: 100vh;
  background-color: $color-gray-darker;

  .color,
  .texture,
  .photo {
    position: fixed;
    overflow: hidden;
    pointer-events: none;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .color {
    z-index: 2;
    background-image: linear-gradient(
      225deg,
      #cb5c22 10%,
      #333333 50%,
      #222222 100%
    );
    opacity: 0.88;
  }

  .texture {
    z-index: 2;
    background-image: url('../assets/images/texture-lines.png');
    background-size: cover;
    background-position: center;
    opacity: 0.32;
    animation: jello 20s infinite;
  }

  .photo {
    z-index: 1;
    background-image: url('../assets/images/background-photo-login.png');
    background-size: cover;
    background-position: center;
    opacity: 0.4;
  }

  .layout {
    z-index: 2;
    width: 324px;
    max-width: 324px;
    max-height: 464px;
    animation: fadeIn 0.8s ease-in-out;

    @include for-size(phone-only) {
      width: 80%;
      min-width: 80%;
      max-width: 80%;
    }

    .flex {
      width: 100%;
      margin: 0;
      padding: 0;
      max-height: 172px;

      .v-text-field {
        margin: 24px 0;
        padding: 0;

        ::v-deep .v-label {
          padding: 0 16px 0 0;
          font-style: italic;
          text-transform: uppercase;
          opacity: 0.48;
        }

        ::v-deep .v-input__append-inner {
          margin-top: 12px;
        }

        ::v-deep ::-webkit-input-placeholder {
          font-style: italic;
          font-weight: 300;
          color: $color-gray-lighter;
        }

        ::v-deep .v-input__slot {
          &::before {
            border-color: rgba($color-gray-lighter, 0.08);
            border-width: 2px 0 0 0;
          }
        }

        .v-input__slot {
          .v-text-field__slot {
            background-color: transparent !important;
          }
        }

        &:last-child {
          margin: 0;
        }
      }

      .link {
        margin: 16px 0 0 0;
      }
    }

    .brand {
      padding: 0 0 40px 0;
      width: 164px;

      @include for-size(phone-only) {
        width: 140px;
      }
    }

    .footer {
      position: relative;
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      width: 100%;
      margin: 40px 0 auto 0;

      .footer_item {
        margin: 0 16px;
      }
    }
  }
}

// Dialog

.v-dialog {
  .v-card {
    padding: 24px;

    @include for-size(phone-only) {
      padding: 16px 8px;
    }

    // Icon
    .row {
      justify-content: center;

      i {
        font-size: 4em;
        opacity: 0.24;
      }
    }

    // Title
    .v-card__title {
      position: relative;
      text-align: center;
      justify-content: center;
      font-style: italic;
      color: $color-gray-dark;
      margin: -8px 0 24px 0;

      @include for-size(phone-only) {
        margin: -8px 0 8px 0;
      }
    }

    // Text
    .v-card__text {
      font-size: 1em;
      color: $color-gray-main;
      text-align: center;

      @include for-size(phone-only) {
        font-size: 0.88em;
        line-height: 1.2em;
      }

      span {
        font-family: 'globotipo' !important;
        font-weight: 700 !important;
        color: $color-gray-dark;
      }

      &.extra {
        width: calc(100% - 16px);
        margin: 0 auto 16px auto;
        padding: 16px;
        font-size: 1em;
        font-style: italic;
        color: $color-gray-dark;
        border-radius: 4px;
        background-color: $color-gray-lighter;

        @include for-size(phone-only) {
          width: calc(100% - 16px);
          font-size: 0.8em;
          line-height: 1.2em;
        }
      }
    }

    @include for-size(phone-only) {
      .v-btn {
        width: 100%;
      }
    }
  }
}
</style>
